import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { ScrollArea } from '@/components/shadcn/scroll-area'
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from '@/components/shadcn/sheet'
import clsx from 'clsx'
import { Suspense } from 'react'
import { FormContentV2 } from '../../../FormComponent'
import { useGetDataForm } from '../../../DataFormComponent/useGetDataForm'
import { InferFormValues, JsonFormSchemaV2 } from '../../../FormComponent/types'
import { transformValuesToTitleValueObjects } from '../../../DataTableV2/utils'
import { StatementEditorV2ContentDataType } from '../../types'

function IndexContentCreateSheetContent({
  contentFormContentId,
  isOpen,
  onOpenChange,
  onAdd,
}: {
  contentFormContentId: string
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  onAdd: (content: Omit<StatementEditorV2ContentDataType, 'id'>) => void
}) {
  const { tileFilterSelections } = useTileFilters()
  const {
    data: {
      uiSchema: {
        schema: { title, description, ...formSchema },
      },
    },
  } = useGetDataForm(contentFormContentId, tileFilterSelections)
  const { properties: formProperties } = formSchema

  const handleSubmit = (data: InferFormValues<JsonFormSchemaV2>) => {
    onAdd({
      ...transformValuesToTitleValueObjects(data, formProperties),
      statements: [],
    })
    onOpenChange(false)
  }

  return (
    <>
      {title ? (
        <SheetHeader className="sticky inset-0 border-b pb-5">
          <SheetTitle>{title}</SheetTitle>
          <SheetDescription>{description ?? ''}</SheetDescription>
        </SheetHeader>
      ) : null}
      <ScrollArea className={clsx(title ? 'h-[calc(100%-77px)]' : 'h-full')}>
        <div className="pl-1 pr-6 pt-4 lg:max-w-[46.75rem]">
          <FormContentV2 schema={formSchema} submitHandler={handleSubmit} resetOnOpen={isOpen} />
        </div>
      </ScrollArea>
    </>
  )
}

export function IndexContentCreateSheet({
  contentFormContentId,
  isOpen,
  onOpenChange,
  onAdd,
}: {
  contentFormContentId: string
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  onAdd: (content: Omit<StatementEditorV2ContentDataType, 'id'>) => void
}) {
  return (
    <Sheet open={isOpen} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-full sm:max-w-lg">
        <Suspense fallback={<div className="p-6 text-muted-foreground">Loading...</div>}>
          <IndexContentCreateSheetContent
            contentFormContentId={contentFormContentId}
            isOpen={isOpen}
            onOpenChange={onOpenChange}
            onAdd={onAdd}
          />
        </Suspense>
      </SheetContent>
    </Sheet>
  )
}
